import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ToastComponent } from '@ui-lib/components';
import { CookieBannerComponent } from './cookie/cookie-banner.component';
import { filter } from 'rxjs';
import { DOCUMENT, ViewportScroller } from '@angular/common';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'rrp-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [RouterOutlet, ToastComponent, CookieBannerComponent],
})
export class AppComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly viewportScroller = inject(ViewportScroller);
  private readonly doc = inject(DOCUMENT);

  public ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const urlTree = this.router.parseUrl(event.url);

        if (urlTree.fragment === null) {
          this.viewportScroller.scrollToPosition([0, 0]);
        }
      });

    if (Capacitor.getPlatform() === 'ios') {
      const meta = this.doc.querySelector('meta[name="viewport"]');
      if (!meta) {
        return;
      }

      meta.setAttribute(
        'content',
        'viewport-fit=cover, width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no',
      );
    }
  }

  protected readonly Capacitor = Capacitor;
}
